import React from 'react';
import MenuWithLogin from '../templates/MenuWithLogin'
import VideoContainer from '../components/container/VideoContainer'

export default function WatchVideo(props) {
  return (
    <MenuWithLogin title='Online CLE' size="xl" loggedIn={props.loggedIn} setLoggedIn={props.setLoggedIn} handleLoginBoxOpen={props.handleLoginBoxOpen} handleSignOut={props.handleSignOut}>
        <VideoContainer vid={props.match.params.vid}></VideoContainer>
        <span></span>
    </MenuWithLogin>
  );
}